import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SharePosition',
    component: () => import(/* webpackChunkName: "SharePosition" */ '../views/share/sharePosition.vue') //职位详情分享
  },
  {
    path: '/shareTeam',
    name: 'ShareTeam',
    component: () => import(/* webpackChunkName: "shareTeam" */ '../views/share/shareTeam.vue') //团队详情分享
  },
  {
    path: '/shareEnterprise',
    name: 'shareEnterprise',
    component: () => import(/* webpackChunkName: "shareEnterprise" */ '../views/share/shareEnterprise.vue') //企业详情分享
  },
  {
    path: '/sharePush',
    name: 'sharePush',
    component: () => import(/* webpackChunkName: "sharePush" */ '../views/share/sharePush.vue') //批推详情分享
  },
  {
    path: '/sharePull',
    name: 'sharePull',
    component: () => import(/* webpackChunkName: "sharePull" */ '../views/share/sharePull.vue') //批招详情分享
  },
  {
    path: '/shareRecruit',
    name: 'shareRecruit',
    component: () => import(/* webpackChunkName: "shareRecruit" */ '../views/share/shareRecruit.vue') //招聘会详情分享
  },
  {
    path: '/shareTrain',
    name: 'shareTrain',
    component: () => import(/* webpackChunkName: "shareTrain" */ '../views/share/shareTrain.vue') //培训城详情分享
  },
  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "shareTrain" */ '../views/download.vue') //培训城详情分享
  }

]

const router = new VueRouter({
  mode: 'history',
  base: "/share/",
  routes
})

export default router